import type { ThematicMeetingListItem, ThematicMeetingTopic } from '@/types/thematic-meetings';

/**
 * The plan titles a meeting can be named after, already read in the reader's language. A topic can
 * have several plans, so a meeting is named after its own plan (`byPlanId`); `byTopic` names a
 * meeting whose plan is no longer in the catalog after its topic. Both are empty while the catalog
 * loads.
 */
export interface MeetingPlanTitles {
    byPlanId: Partial<Record<string, string>>;
    byTopic: Partial<Record<ThematicMeetingTopic, string>>;
}

/**
 * The title a meeting shows: the one its manager gave it, or else its plan's title, or else its
 * topic's label. Undefined while none is known — the template catalog still loading, for a meeting
 * with no title of its own.
 */
export const getMeetingTitle = (
    meeting: Pick<ThematicMeetingListItem, 'title' | 'topic' | 'meetingPlanTemplateId'>,
    planTitles: MeetingPlanTitles,
): string | undefined =>
    meeting.title ??
    planTitles.byPlanId[meeting.meetingPlanTemplateId] ??
    planTitles.byTopic[meeting.topic];
